module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-caret-down-c5e8011bf824a73557da02421febd342.svg";